import React from "react";
import { WebhookListView } from "domains/webhooks/components/WebhookListView";

export const WebhookListPage: React.FC = () => {
  return <WebhookListView />;
};
